export default __webpack_public_path__ + "static/media/2020-Typsa.94c4a234.jpeg";